import styles from './TextField.module.css';

export interface TextFieldProps {
  id: string;
  label: string;
  /** Datum en tijd: gebruik DateField / TimeField (DateTimeField.tsx). */
  type?: 'text' | 'email' | 'password' | 'number' | 'tel' | 'search';
  value: string;
  onInput: (value: string) => void;
  autoComplete?: string;
  inputMode?: 'text' | 'numeric' | 'decimal' | 'email' | 'tel' | 'search' | 'url';
  placeholder?: string;
  error?: string | undefined;
  /** Hulptekst onder het veld (bv. "Minimaal 12 tekens"). */
  hint?: string | undefined;
  required?: boolean;
  disabled?: boolean;
  autoFocus?: boolean;
  maxLength?: number;
  min?: string | number;
  max?: string | number;
  step?: string | number;
  pattern?: string;
  name?: string;
}

export function TextField({
  id,
  label,
  type = 'text',
  value,
  onInput,
  autoComplete,
  inputMode,
  placeholder,
  error,
  hint,
  required,
  disabled,
  autoFocus,
  maxLength,
  min,
  max,
  step,
  pattern,
  name,
}: TextFieldProps) {
  const describedBy = error ? `${id}-error` : hint ? `${id}-hint` : undefined;
  return (
    <div class={styles.field}>
      <label class={styles.label} for={id}>
        {label}
      </label>
      <input
        id={id}
        name={name ?? id}
        class={styles.input}
        type={type}
        value={value}
        autoComplete={autoComplete}
        inputMode={inputMode}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        autoFocus={autoFocus}
        maxLength={maxLength}
        min={min}
        max={max}
        step={step}
        pattern={pattern}
        aria-invalid={error ? 'true' : undefined}
        aria-describedby={describedBy}
        onInput={(e) => onInput((e.currentTarget as HTMLInputElement).value)}
      />
      {error ? (
        <span id={`${id}-error`} class={styles.error} role="alert">
          {error}
        </span>
      ) : hint ? (
        <span id={`${id}-hint`} class={styles.hint}>
          {hint}
        </span>
      ) : null}
    </div>
  );
}
